module.exports = __webpack_public_path__ + "img/facebook-icon.0f3c565d.svg";